import SubjectAchievement, { subjectKeyForCoterie } from "./SubjectAchievement";
import { retrieveSubjectStyle } from "../../../utilization/SubjectUtilization";

// SubjectIcon — renders the design system's soft-3D SubjectAchievement illustration for
// a coterieType (subject). Subjects without a design illustration (e.g. physical
// education, traffic safety) fall back to the legacy .webp icon image.
export default function SubjectIcon({
  coterieType,
  size = 40,
}: {
  coterieType?: string;
  size?: number;
}) {
  const key = subjectKeyForCoterie(coterieType);
  if (key) {
    return <SubjectAchievement subject={key} size={size} />;
  }
  return (
    <img
      src={retrieveSubjectStyle(coterieType).icon}
      alt=""
      style={{ width: size, height: size, objectFit: "contain", flexShrink: 0 }}
    />
  );
}
